import { isRewardfulEnabled, rewardfulApiKey } from '../config/app';

// Rewardful affiliate tracking (Stripe Checkout server-side method).
// The snippet below is the one Rewardful prescribes for our account; it has
// to be present on every page. Rewardful handles the `?via=<token>` affiliate
// link parameter and its own cookie, so nothing is captured or stored here.
const rewardful = {
    init: () => {
        if (!isRewardfulEnabled) {
            return false;
        }

        const queue = document.createElement("script");
        queue.innerHTML = "(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful');";

        const loader = document.createElement("script");
        loader.async = true;
        loader.src = "https://r.wdfl.co/rw.js";
        loader.setAttribute("data-rewardful", rewardfulApiKey);

        document.head.appendChild(queue);
        document.head.appendChild(loader);
    },
    // Referral id (UUID) of the visitor when they arrived via an affiliate
    // link, empty string otherwise. Sent to the backend which forwards it to
    // Stripe as `client_reference_id`.
    getReferral: () => {
        return window.Rewardful && window.Rewardful.referral ? window.Rewardful.referral : '';
    },
};

export const getReferral = rewardful.getReferral;

export default rewardful;
